module.exports = __webpack_public_path__ + "img/firefly.a4f47f2d.png";